module.exports = __webpack_public_path__ + "static/media/cptm_doc3.fee438af.JPG";